export const ONE_TIME_DISCOUNT_LABEL_TRANSLATION_KEY =
  'one_time_discount_label';

export const FINITE_DISCOUNT_LABEL_TRANSLATION_KEY = 'finite_discount_label';
export const MANUAL_LABEL_TRANSLATION_KEY = 'tables.merchant_discount';
export const FIXED_AMOUNT_DISCOUNT = 'FIXED_AMOUNT';
export const PERCENTAGE_DISCOUNT = 'PERCENTAGE';
export const CODE_DISCOUNT_TYPE = 'CODE_DISCOUNT';
export const MANUAL_DISCOUNT_TYPE = 'MANUAL';

export const MOCK_AUTH_TOKEN = 'auth-token-1234';
export const MOCK_CUSTOMER_ID = 'customer-abc';
